import { useUser } from 'components/providers/UserProvider'
import { getDashboardStockSummary } from 'lib/api'
import { useEffect, useState } from 'react'
import { GAME_IDS, GAME_NAMES, IdGame } from 'shared'

export interface GameStockBreakdown {
  gameId: IdGame
  gameName: string
  singlesValue: number
  sealedValue: number
  totalValue: number
}

export interface StockSummary {
  stockValue: number
  uniqueArticles: number
  totalItems: number
  soldItems: number
  loading: boolean
  gameBreakdown: GameStockBreakdown[]
}

export const useAllGamesStockSummary = (): StockSummary => {
  const { user } = useUser()
  const [summary, setSummary] = useState<StockSummary>({
    stockValue: 0,
    uniqueArticles: 0,
    totalItems: 0,
    soldItems: 0,
    loading: true,
    gameBreakdown: [],
  })

  useEffect(() => {
    if (!user?.username) return

    const loadStockSummary = async () => {
      try {
        // Every game, not the ones whose stock this browser happens to have saved: the figures must
        // be the same on every device
        const data = await getDashboardStockSummary([0, ...GAME_IDS, 99])

        const gameBreakdown: GameStockBreakdown[] = data.gameBreakdown.map((game) => ({
          gameId: game.idGame as IdGame,
          gameName: GAME_NAMES[game.idGame] || `Game ${game.idGame}`,
          singlesValue: game.singlesValue,
          sealedValue: game.sealedValue,
          totalValue: game.totalValue,
        }))

        setSummary({
          stockValue: data.stockValue,
          uniqueArticles: data.uniqueArticles,
          totalItems: data.totalItems,
          soldItems: data.soldItems,
          loading: false,
          gameBreakdown,
        })
      } catch {
        setSummary((prev) => ({ ...prev, loading: false }))
      }
    }

    loadStockSummary()
  }, [user?.username])

  return summary
}
